module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/polizas/polizas-editar/polizas-editar.component.scss
// module id = ./src/app/Contabilidad/polizas/polizas-editar/polizas-editar.component.scss
// module chunks = main